import { Component, inject, InjectionToken, Type, ViewChild } from '@angular/core';

import { DropdownItemComponent } from '../../../../common/dropdown/dropdown-item/dropdown-item.component';
import { Select2Item } from '../../types';
import { Select2ListItemDirective } from './list-item.directive';

export const DEFAULT_LIST_ITEM_COMPONENT = new InjectionToken<Type<Select2DefaultItemComponent>>(
  'default list item',
);

@Component({
  selector: 'rt-select-list-item',
  standalone: true,
  imports: [Select2ListItemDirective, DropdownItemComponent],
  template: `
    <ng-container
      *rtSelectListItem="
        selectType;
        let selectCtrl;
        let item = item;
        let isHoverState = isHoverState;
        let index = index
      "
    >
      <rt-dropdown-item (click)="selectCtrl.select$.next(item)" [class.hover]="isHoverState">
        {{ item.label }}
      </rt-dropdown-item>
    </ng-container>
  `,
  styleUrls: ['./list-item.component.less'],
  providers: [
    {
      provide: Select2ListItemDirective,
      useFactory: () => inject(Select2DefaultItemComponent).directive,
    },
  ],
})
export class Select2DefaultItemComponent {
  @ViewChild(Select2ListItemDirective, { static: true })
  public directive: Select2ListItemDirective<any>;
  public selectType: { items: Select2Item[] };
}
